import React from 'react';
import styled from '@emotion/styled';
import Test from 'react-test-attributes';

import RichText from 'components/common/RichText';

import media from 'utils/media';
import useAccordion from 'utils/hooks/useAccordion';

import arrowDown from 'assets/icons/arrow-down.svg';

export default function Accordion({ title, content, crossIcon, gtmClassName, gtmTrackId }) {
  const [contentRef, toggleAccordion, contentHeight] = useAccordion();

  return (
    <StyledAccordion>
      <Test id="faq-question">
        <Title onClick={toggleAccordion} id={gtmTrackId || ''} className={gtmClassName || ''}>
          <span id={gtmTrackId || ''} className={gtmClassName || ''}>
            {title}
          </span>
          <Test id="faq-icon">
            {crossIcon ? (
              <CrossIcon id={gtmTrackId || ''} className={gtmClassName || ''} visible={contentHeight > 0} />
            ) : (
              <ArrowIcon
                id={gtmTrackId || ''}
                className={gtmClassName || ''}
                src={arrowDown}
                isRotated={contentHeight > 0}
                alt="arrow down"
                loading="lazy"
              />
            )}
          </Test>
        </Title>
      </Test>
      <Test id="faq-answer">
        <Content isExpanded={contentHeight > 0} height={contentHeight}>
          {content && (
            <div ref={contentRef}>
              <RichText document={content} />
            </div>
          )}
        </Content>
      </Test>
    </StyledAccordion>
  );
}

export const StyledAccordion = styled.div`
  width: 100%;
  margin-bottom: 5px;
  padding: 10px 20px;
  text-align: left;
  overflow: hidden;

  ${media.greaterThan.md} {
    padding: 21px 55px;
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  cursor: pointer;

  span {
    width: 90%;
    font-size: 18px;
    line-height: 27px;
  }
`;

const CrossIcon = styled.div`
  position: relative;
  width: 20px;
  height: 20px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colors.accent};
  }

  &:before {
    width: 100%;
    height: 2px;
    top: 50%;
    transform: translateY(-50%);
  }

  &:after {
    width: 2px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    opacity: ${({ visible }) => (visible ? 0 : 1)};
    transition: 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  }
`;

const ArrowIcon = styled.img`
  width: 10px;
  height: 27px;
  transform: ${({ isRotated }) => (isRotated ? 'rotate(180deg)' : 'rotate(0)')};
  transition: 0.3s cubic-bezier(0.77, 0, 0.175, 1);
`;

const Content = styled.div`
  height: ${({ height }) => (height ? `${height + 20}px` : `${height}px`)};
  visibility: ${({ isExpanded }) => (isExpanded ? 'visible' : 'hidden')};
  transition: 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  overflow: ${({ isExpanded }) => (isExpanded ? 'visible' : 'hidden')};
  opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
  transition-property: opacity, visibility, height;
  transition-delay: 0.1s, 0s, 0s;

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 20px 0;
  }
`;
